import React, { useState, useContext, useRef, FormEvent, useEffect } from "react";
import DataContext from "../../Context";
import { IPolicy } from "../../Models/PolicyInfo";
import { useNavigate } from "react-router-dom";
import "./Policy.css";
import Title from "../../Components/Title";
import Button from "../../Components/Button";
import ButtonGroup from "../../Components/ButtonGroup";
import Label from "../../Components/Label";
import TextInput from "../../Components/TextInput";
import FormRow from "../../Components/FormRow";
import ValidationError from "../../Components/ValidationError";
import useWarnRefresh from "../../hooks/useWarnRefresh";
import { ILocalizationContext } from "../../Localization/Models/ILocalizationContext";
import LocalizationContext from "../../Localization/LanguageContext";

const PolicyForm = () => {
  const {
    firstName,
    setFirstName,
    lastName,
    setLastName,
    policy,
    setPolicy,
    setProgressState, 
    isSanitized
  } = useContext(DataContext) as IPolicy;
  const { getValue } = useContext(LocalizationContext) as ILocalizationContext;

  useWarnRefresh();

  const scrollRef = useRef<HTMLInputElement>(null);

  const [fnRequired, setFnReq] = useState<boolean>(false);
  const [lnRequired, setLnReq] = useState<boolean>(false);
  const [dataFail, setDataFail] = useState<boolean>(false);

  useEffect(() => {
    setProgressState(1);
  }, []);

  let navigator = useNavigate();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    
    setFirstName(firstName.trim());
    setLastName(lastName.trim());
    setPolicy(policy.trim());

    if (!IsDataValid()) {
      setTimeout(handleErrorCheck, 10);
    }
    if (IsDataValid()) {
      navigator("/CompanyInfo", { replace: true });
    }

    if (!firstName || !lastName) {
      FNblur();
      LNblur();
    }
  };

  const FNblur = () => {
    if (!firstName.trim()) setFnReq(true);
  };
  const FNfocus = () => {
    setFnReq(false);
  };
  const LNblur = () => {
    if (!lastName.trim()) setLnReq(true);
  };
  const LNfocus = () => {
    setLnReq(false);
  };

  let IsDataValid = () => {
    if (
      !firstName.trim() || !isSanitized(firstName) ||
      !lastName.trim() || !isSanitized(lastName)
    )
      return false;
    return true;
  };
  const handleErrorCheck = () => {
    const input = document.querySelector(`.input-error,.check-error`);

    input?.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "start",
    });
  };

  return (
    <div className="PolicyPage position-relative">
      <div className="container form-container px-4">
        <form onSubmit={handleSubmit} className="policy-info-form">
          <FormRow>
            <Title
              contentDescription={getValue('PolicyForm', 'Title')}
              instructionDescription={getValue('PolicyForm', 'TitleSub')}
            />
          </FormRow>
          <FormRow>
            <Label>{getValue('PolicyForm', 'FirstNameLabel')}</Label>
            <TextInput
              inputId="FirstName"
              inputValue={firstName}
              isInvalid={fnRequired || !isSanitized(firstName)}
              onChange={(e) => setFirstName(e.target.value)}
              onBlur={FNblur}
              onFocus={FNfocus}
              errorMessage={getValue('PolicyForm','ValFirstName')}
              maxLength={50}
            />
          </FormRow>
          <FormRow>
            <Label>{getValue('PolicyForm', 'LastNameLabel')}</Label>
            <TextInput
              inputId="LastName"
              inputValue={lastName}
              isInvalid={lnRequired || !isSanitized(lastName)}
              onChange={(e) => setLastName(e.target.value)}
              onBlur={LNblur}
              onFocus={LNfocus}
              errorMessage={getValue('PolicyForm','ValLastName')}
              maxLength={50}
            />
          </FormRow>
          <ValidationError
            isInvalid={dataFail}
            message="The policy number, and/or FEIN you provided do not match our records. Please check your entries and try again."
          />
          <ButtonGroup>
            <span className="col-md-6 my-2" />
            <span className="col-md-6 my-2">
              <Button
                type="submit"
                bootstrap="col-12"
                version={IsDataValid() ? "primary" : "disabled"}
              >
                {getValue('PolicyForm', 'Next')}
              </Button>
            </span>
          </ButtonGroup>
        </form>
      </div>
      <div id="scrollbase" ref={scrollRef} />
    </div>
  );
};

export default PolicyForm;
